import { render, staticRenderFns } from "./BackgroundMockup.vue?vue&type=template&id=d13e6c82&"
import script from "./BackgroundMockup.vue?vue&type=script&lang=js&"
export * from "./BackgroundMockup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports